export default __webpack_public_path__ + "static/media/PuntangNatural.ef1b219f.png";